import FJUtil from './FJUtil';

const FJArrayUtil = {
    /**
     * @description 数组去重
     * @param {any[]} arr
     * @returns
     */
    uniq: function (arr) {
        return Array.from(new Set(arr));
    },
    /**
     * @description 移除数组中的某个元素
     * @param array
     * @param item
     */
    removeFromArray: function (array, item) {
        if (!Array.isArray(array)) {
            console.error(new TypeError('ERR_ARGUMENTS'));
            return;
        }
        let index = array.indexOf(item);
        if (index !== -1) {
            array.splice(index, 1);
        }
    },
    /**
     * @description 添加元素到数组
     * @param array
     * @param item
     * @param index {undefined | number} 插入的索引，如果没传则插入到末尾
     */
    addToArray: function (array, item, index) {
        if (FJUtil.isUndefined(index)) {
            array.push(item);
        } else {
            array.splice(index, 0, item);
        }
    },
    /**
     * @description 返回数组的第一个元素
     * @param {*} array
     * @returns
     */
    headOfArrayLike: function (array) {
        return array[0];
    },
    /**
     * @description 返回数组的最后一个元素
     * @param {*} array
     * @returns
     */
    tailOfArrayLike: function (array) {
        return array[array.length - 1];
    },
};

export default FJArrayUtil;
